import React, { createContext, useContext, useState , ReactNode, useEffect} from 'react';
import { OperationsRowType , OperationsResponse} from '../types/operations';
import axios from 'axios';
import api from "../api/axiosClient"


interface OperationsContextType {
  operations: OperationsRowType[]
  addOperation: (sorter: number, belt:number, recipe:number, time:string, status:number)=>void;
}

interface OperationsProviderProps {
  children: ReactNode;
}

const OperationContext = createContext<OperationsContextType | undefined>(undefined);
export const useOperations = (): OperationsContextType  => {
  const context = useContext(OperationContext);
  if (!context) {
    throw new Error("useRecipes must be used within a RecipeProvider");
  }
  return context;
};

export const OperationsProvider = ({ children }: OperationsProviderProps) => {
    const [operations, setOperations] = useState<OperationsRowType[]>([]);

    useEffect(() => {
        const fetchOperations = async () => {
        try {
            const response = await api.get<OperationsRowType[]>(`/sorter/belt/schedules`);
            setOperations(response.data);
        } catch (error) {
            console.error("Error fetching operations:", error);
            setOperations([])
        }};
        fetchOperations();
    }, []);



  const addOperation = async (sorter: number, belt:number, recipe:number, time:string, status:number) => {
      const newOperationDB={
          "sorter_belt_id":belt,
          "name":"",
          "recipe_id":recipe,
          "effective_from": time, 
          "status_id": status
      }

      const response = await api.post(`/sorter/belt/schedules/create`, newOperationDB)

      const newOperation={
        "operation_id":response.data.id,
        "sorter_id":sorter,
        "belt_id": belt,
        "recipe_id":recipe,
        "effective_from": new Date(time), 
        "status_id": status
      }
      setOperations(prev => [...prev, newOperation]);
      return newOperation.operation_id;
  };




  return (
    <OperationContext.Provider value={{ operations, addOperation}}>
      {children}
    </OperationContext.Provider>
  );
};
